import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AddToolsModel } from '../Models/addToolsModel';
import { BehaviorSubject, Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class ToolsComponentService {
  private PrepopulateData = new BehaviorSubject<any>({});
  public PrepopulateData$: Observable<any> = this.PrepopulateData.asObservable();

  private isCopy: BehaviorSubject<boolean>;
  private isView: BehaviorSubject<boolean>;

  constructor(private http: HttpClient,
  ) {

    this.isCopy = new BehaviorSubject<boolean>(false);
    this.isView = new BehaviorSubject<boolean>(false);
  }
  httpOptions = {
    headers: new HttpHeaders(
      {
        Accept: 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('token')
      },
    ),
  };
  private GSDapiUrl = environment.GSDapiUrl;
  private apiUrl = environment.apiUrl;
  toolsId?: number;

  setFormData(data) {
    this.PrepopulateData.next(data);

  }

  getCopyButtonStatus(): Observable<any> {
    return this.isCopy.asObservable();
  }

  setCopyButtonStatus(copyButton: boolean) {
    this.isCopy.next(copyButton);
  }

  getViewButtonStatus(): Observable<any> {
    return this.isView.asObservable();
  }

  setViewButtonStatus(viewButton: boolean) {
    this.isView.next(viewButton);
  }

  getTools(compId: number, subCompId: number, tooltypeid: number) {
    const url = `${this.GSDapiUrl}Tool/GetToolsList?competencyId=${compId}&subCompetencyId=${subCompId}&typeId=${tooltypeid}`;
    return this.http.get<any>(url, this.httpOptions);
  }

  public addToolDetails(data: AddToolsModel): Observable<any> {
    const url = this.GSDapiUrl + 'Tool/SaveTool';
    return this.http.post<AddToolsModel>(url, data, this.httpOptions);
  }

  getToolType() {
    const url = `${this.GSDapiUrl}Tool/GetToolsType`;
    return this.http.get<any>(url, this.httpOptions);
  }

  public deleteToolApiCall(toolId: string): Observable<any> {
    const url = this.GSDapiUrl + 'Tool/DeleteTool?toolId=' + toolId;
    return this.http.delete<any>(url);
  }

  public getId(Id?: number) {
    this.toolsId = Id;
  }

  public getToolDetailsById(): Observable<any> {
    const url = this.GSDapiUrl + 'Tool/GetToolById?toolId=' + this.toolsId;
    return this.http.get<AddToolsModel[]>(url, this.httpOptions);
  }
  public getReviewerId() {
    const url = this.apiUrl + `Profile/GetSpecificRoles`;
    return this.http.get<any>(url, this.httpOptions);
  }
}